export function marketEvidenceConfidence(coverage: CoverageState | null | undefined): "medium" | "low" {
  const evidence=coverage?.market?.evidence;
  if (!evidence) return "low";
  return evidence.comparisons.filter(c=>c.selected).length >= 5
    && evidence.reasons.every(reason=>reason==="condition_not_structured_no_adjustment") ? "medium" : "low";
}

export interface CoverageState {
  policyVersion: string;
  maximum: number;
  error: string | null;
  market: {
    revision: number;
    market_value: number;
    evidence: {
      provisional: boolean;
      reasons: string[];
      comparisons: Array<{
        price: number; year: number; model: string; bodyStyle: string;
        date: string | null; source: string | null; url: string | null;
        selected: boolean; reasons: string[];
      }>;
    };
  } | null;
  consent: {
    accepted_amount: number | null; accepted_at: string | null;
    accepted_market_value: number | null; policy_version: string;
    partial_coverage_acknowledged: boolean; consent_valid: boolean;
    refused_at: string | null; admin_proposed_amount: number | null;
  } | null;
}
